import React, { useEffect, useState, useCallback } from 'react';
import { localToday } from '../../utils/dateUtils';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import PageHeader from '../../components/PageHeader';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { toast } from 'react-toastify';
import { useUsers } from '../../context/usersContext';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import useSubmitLock from '../../utils/useSubmitLock';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';

const Testes = () => {
  const { listInternals } = useInternals();
  const { listTypeTest } = useAuxiliaries();
  const { userInfo, buildUnitReadParams } = useUsers();

  const { createMedicalTest, listMedicalTest } = useInternals();

  const [internalDetails, setInternalDetails] = useState(null);
  const [typeTestList, setTypeTestList] = useState([]);
  const [timeline, setTimeline] = useState([]);
  const [previousTest, setPreviousTest] = useState('nao');
  const [knownPositive, setKnownPositive] = useState('nao');
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();
  const [form, setForm] = useState({
    date: localToday(),
    nextDate: '',
    typeTest: '',
    made: 'false',
    reactant: 'false',
    inconclusive: 'false',
    observation: '',
    file: null,
    internal: '',
  });

  const loadTypeTests = useCallback(async () => {
    try {
      const resp = await listTypeTest();
      setTypeTestList(resp?.results || []);
    } catch (err) {
      console.error('Erro ao carregar tipos de teste', err);
    }
  }, [listTypeTest]);

  useEffect(() => {
    loadTypeTests();
  }, [loadTypeTests]);

  const handleInternalSelect = async (internal) => {
    setInternalDetails(internal);
    try {
      if (!internal?.id) return;
      const resp = await listInternals(buildUnitReadParams({ id: internal.id }));
      const selected = resp?.results?.[0];
      if (selected) {
        setInternalDetails(selected);
        setForm((prev) => ({ ...prev, internal: selected.id }));
        await loadTests(selected.id);
      }
    } catch (err) {
      console.error('Erro ao buscar interno', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setForm((prev) => ({ ...prev, file: files?.[0] || null }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const loadTests = useCallback(
    async (internalId) => {
      if (!internalId) return;
      try {
        const resp = await listMedicalTest(internalId);
        setTimeline(resp?.results || []);
      } catch (err) {
        console.error('Erro ao listar testes', err);
      }
    },
    [listMedicalTest]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!internalDetails?.id) {
        toast.error('Selecione um interno.');
        return;
      }
      if (!form.typeTest) {
        toast.error('Selecione o tipo de teste.');
        return;
      }
      if (!form.observation || !form.observation.trim()) {
        toast.error('Informe a observação.');
        return;
      }
      try {
        const fd = new FormData();
        fd.append('internal', internalDetails.id);
        fd.append('type_test', form.typeTest);
        fd.append('date', form.date);
        fd.append('next_date', form.nextDate);
        fd.append('made', form.made);
        fd.append('reactant', form.reactant);
        fd.append('inconclusive', form.inconclusive);
        fd.append('observation', form.observation.trim());
        fd.append('health_professional', userInfo?.id || '');
        if (form.file) fd.append('file', form.file);

        await createMedicalTest(fd);
        await loadTests(internalDetails.id);

        setForm((prev) => ({
          ...prev,
          date: localToday(),
          nextDate: '',
          typeTest: '',
          made: 'false',
          reactant: 'false',
          inconclusive: 'false',
          observation: '',
          file: null,
        }));
        toast.success('Teste registrado.');
      } catch (err) {
        console.error('Erro ao salvar teste', err);
        toast.error('Erro ao salvar teste.');
      }
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Testes rápidos"
          subtitle="Registro e acompanhamento de testagens."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
        <div className="health-card" style={{ marginTop: 16, background: '#fff' }}>
          <form onSubmit={handleSubmit}>
            <div className="tb-section-block">
              <h4 className="h4-title">Cadastro de Testes Rápidos</h4>

              {/* PENDENTE: nenhuma pergunta deste bloco é salva. "Já realizou teste
                  anteriormente?", "Quais testes já realizou?", "Sabidamente positivos?"
                  e "Aceita realizar teste para ISTs?" (+ os 2 campos condicionais "Se
                  sim...") não têm campo correspondente no schema de InternalMedicalTest
                  (/api/schema/) — não estão nem no FormData do handleSubmit. Antes de
                  conectar isso a algum state, confirmar com o backend se esses campos
                  vão existir na API; sem isso não há onde persistir a resposta. */}
              <div className="health-grid-two" style={{ marginBottom: 12 }}>
                <div className="health-option-set">
                  <p className="health-subtitle">Já realizou teste anteriormente?</p>
                  <div className="health-options-row">
                    <label className="health-option">
                      <input
                        type="radio"
                        name="teste-anterior"
                        value="nao"
                        checked={previousTest === 'nao'}
                        onChange={(e) => setPreviousTest(e.target.value)}
                      />
                      Não
                    </label>
                    <label className="health-option">
                      <input
                        type="radio"
                        name="teste-anterior"
                        value="sim"
                        checked={previousTest === 'sim'}
                        onChange={(e) => setPreviousTest(e.target.value)}
                      />
                      Sim
                    </label>
                  </div>
                  {previousTest === 'sim' && (
                    <input type="text" className="health-inline-input highlight" placeholder="Se sim, informe data ou período" />
                  )}
                </div>

                <div className="health-option-set">
                  <p className="health-subtitle">Quais testes já realizou?</p>
                  <div className="health-options-row">
                    {['HIV', 'Sífilis', 'Hepatite B e C'].map(opt => (
                      <label key={opt} className="health-option">
                        <input type="checkbox" /> {opt}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="health-option-set">
                  <p className="health-subtitle">Sabidamente positivos?</p>
                  <div className="health-options-row">
                    <label className="health-option">
                      <input
                        type="radio"
                        name="positivos"
                        value="nao"
                        checked={knownPositive === 'nao'}
                        onChange={(e) => setKnownPositive(e.target.value)}
                      />
                      Não
                    </label>
                    <label className="health-option">
                      <input
                        type="radio"
                        name="positivos"
                        value="sim"
                        checked={knownPositive === 'sim'}
                        onChange={(e) => setKnownPositive(e.target.value)}
                      />
                      Sim
                    </label>
                  </div>
                  {knownPositive === 'sim' && (
                    <input type="text" className="health-inline-input highlight" placeholder="Se sim, quais?" />
                  )}
                </div>

                <div className="health-option-set">
                  <p className="health-subtitle">Aceita realizar teste para ISTs?</p>
                  <div className="health-options-row">
                    <label className="health-option"><input type="radio" name="aceita-teste" /> Não</label>
                    <label className="health-option"><input type="radio" name="aceita-teste" /> Sim</label>
                  </div>
                </div>
              </div>

              <div className="tb-row">
                <div className="tb-col">
                  <label>Data do teste</label>
                  <input type="date" name="date" value={form.date} onChange={handleChange} />
                </div>
                <div className="tb-col">
                  <label>Data do próximo teste</label>
                  <input type="date" name="nextDate" value={form.nextDate} onChange={handleChange} />
                </div>
                <div className="tb-col">
                  <label>Tipo de teste</label>
                  <select name="typeTest" value={form.typeTest} onChange={handleChange}>
                    <option value="">Selecione</option>
                    {typeTestList.map((type) => (
                      <option key={type.id} value={type.id}>{type.name}</option>
                    ))}
                  </select>
                </div>
                <div className="tb-col">
                  <label>Realizado na unidade?</label>
                  <div className="toggle-field">
                    <span className={`toggle-label ${form.made === 'false' ? 'active' : ''}`}>Não</span>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={form.made === 'true'}
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, made: e.target.checked ? 'true' : 'false' }))
                        }
                      />
                      <span className="toggle-slider" />
                    </label>
                    <span className={`toggle-label ${form.made === 'true' ? 'active' : ''}`}>Sim</span>
                  </div>
                </div>
                <div className="tb-col">
                  <label>Reagente</label>
                  <div className="toggle-field">
                    <span className={`toggle-label ${form.reactant === 'false' ? 'active' : ''}`}>Não</span>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={form.reactant === 'true'}
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, reactant: e.target.checked ? 'true' : 'false' }))
                        }
                      />
                      <span className="toggle-slider" />
                    </label>
                    <span className={`toggle-label ${form.reactant === 'true' ? 'active' : ''}`}>Sim</span>
                  </div>
                </div>
                <div className="tb-col">
                  <label>Inconclusivo</label>
                  <div className="toggle-field">
                    <span className={`toggle-label ${form.inconclusive === 'false' ? 'active' : ''}`}>Não</span>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={form.inconclusive === 'true'}
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, inconclusive: e.target.checked ? 'true' : 'false' }))
                        }
                      />
                      <span className="toggle-slider" />
                    </label>
                    <span className={`toggle-label ${form.inconclusive === 'true' ? 'active' : ''}`}>Sim</span>
                  </div>
                </div>
                <div className="tb-col flex-1">
                  <label>Observação</label>
                  <textarea
                    name="observation"
                    rows="3"
                    value={form.observation}
                    onChange={handleChange}
                    maxLength={200}
                    required
                  />
                  <span className="admission-card__hint">
                    {(form.observation || '').length}/200 caracteres
                    {(form.observation || '').length >= 200 && ' — Limite atingido!'}
                  </span>
                </div>
                <div className="tb-col">
                  <label>Arquivo (PDF)</label>
                  <input type="file" accept="application/pdf" name="file" onChange={handleChange} />
                </div>
              </div>

              <div className="social-form-group" style={{ marginTop: 12 }}>
                <button type="submit" className="social-submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="timeline content" style={{marginTop: "10px"}}>
          <h4>Histórico de Testes Rápidos</h4>
          <ul className="timeline-list">
            {timeline.length > 0 ? (
              timeline.map((item) => (
                <li key={item.id} className="timeline-item">
                  <div className="timeline-date">
                    {item.date ? new Date(item.date).toLocaleDateString() : '-'}
                  </div>
                  <div className="timeline-content">
                    <p><strong>Tipo:</strong> {item.type_test_name || item.type_test || item.typeTest || '-'}</p>
                    <p><strong>Próximo teste:</strong> {item.next_date ? new Date(item.next_date).toLocaleDateString() : (item.nextDate || '-')}</p>
                    <p><strong>Realizado na unidade:</strong> {item.made ? 'Sim' : 'Não'}</p>
                    <p><strong>Reagente:</strong> {item.reactant ? 'Sim' : 'Não'}</p>
                    <p><strong>Inconclusivo:</strong> {item.inconclusive ? 'Sim' : 'Não'}</p>
                    <p><strong>Observação:</strong> {item.observation || '-'}</p>
                    {hasBinaryField(item, 'file') && (
                      <p>
                        <BinaryFileLink resource={BINARY_RESOURCES.internalMedicalTest} id={item.id} field="file">Ver arquivo</BinaryFileLink>
                      </p>
                    )}
                  </div>
                </li>
              ))
            ) : (
              <p>Nenhum teste registrado.</p>
            )}
          </ul>
        </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Testes;
